import classNames from 'classnames';
import { FlexContainer } from 'components';
import { userTypeOptions } from 'config/userFields';
import { AccountTypeItem } from './components';
import styles from './SelectAccountType.module.scss';

/**
 * SelectAccountType
 *
 * @return {JSX.Element}
 */
const SelectAccountType = ({ className, onSelect }) => {
  const handleClick = (key) => () => onSelect(key);

  return (
    <FlexContainer
      className={classNames(
        styles.SelectAccountType,
        className,
        SelectAccountType.displayName
      )}
      column
      gap
    >
      {userTypeOptions.map((uType) => (
        <AccountTypeItem
          key={uType.key}
          item={uType}
          onClick={handleClick(uType.key)}
        />
      ))}
    </FlexContainer>
  );
};

SelectAccountType.displayName = 'SelectAccountType';

export default SelectAccountType;
